import { TableMap } from '../table-map';
import { findTable } from './find';

// Returns an array of cells in a column(s), where `columnIndex` could be a column index or an array of column indexes.
export var getCellsInColumn = function getCellsInColumn(columnIndexes) {
  return function (selection) {
    var table = findTable(selection);
    if (!table) {
      return;
    }
    var map = TableMap.get(table.node);
    var indexes = Array.isArray(columnIndexes) ? columnIndexes : [columnIndexes];
    return indexes.filter(function (index) {
      return index >= 0 && index <= map.width - 1;
    }).reduce(function (acc, index) {
      var cells = map.cellsInRect({
        left: index,
        right: index + 1,
        top: 0,
        bottom: map.height
      });
      return acc.concat(cells.map(function (nodePos) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var node = table.node.nodeAt(nodePos);
        var pos = nodePos + table.start;
        return {
          pos: pos,
          start: pos + 1,
          node: node,
          depth: table.depth + 2
        };
      }));
    }, []);
  };
};